import './App.css';
import Slider from './Slider';
import Header from './Header';
import Footer from './Footer';
import MobileHeader from './MobileHeader';
import MobileFooter from './MobileFooter';
import ProjectDetailsMobile from './ProjectDetailsMobile';
import Typefaces from './Typefaces';
import Navigation from './Navigation';
import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import ProjectDetails from './ProjectDetails';
import AboutDetails from './AboutDetails';
import Imprint from './Imprint';
import arrowBlackSvg from './assets/images/arrow-black.svg';
import arrowWhiteSvg from './assets/images/arrow-white.svg';
import { isMobile } from 'react-device-detect';
import AboutDetailsMobile from './AboutDetailsMobile';
import { Virtual } from 'swiper/modules';

const mediaFiles = require.context('./assets/projects', true, /^\.\/.*\/.*(\.mp4|\.jpg|\.png|\.webm|\.svg|\.gif)$/);

const mediaFilesByFolder = mediaFiles.keys().filter((key) => !key.includes('_POSTER-ATTRIBUTE.jpg')).reduce((acc, key) => {
  const folder = key.split('/')[1];
  const video = mediaFiles(key);

  let posterImage;

  if (key.endsWith('.mp4')) {
    // Get the filename without extension, handling the leading ./
    let posterImageKey = key.substring(0, key.lastIndexOf('.')) + '_POSTER-ATTRIBUTE.jpg';

    try {
      posterImage = mediaFiles(posterImageKey);
    } catch {
      posterImageKey = key.substring(0, key.lastIndexOf('.')) + '_POSTER-ATTRIBUTE.png';
      posterImage = mediaFiles(posterImageKey);
    }
  }

  const json = require(`./assets/projects/${folder}/projectMeta.json`);

  const folderIndex = acc.findIndex((arr) => arr[0].folder === folder);

  if (folderIndex !== -1) {
    acc[folderIndex].push({ folder, video, ...json, posterImage });
  } else {
    acc.push([{ folder, video, ...json, posterImage }]);
  }

  return acc;
}, []);

const projectFolderSizes = mediaFilesByFolder.map((folder) => folder.length);
const projectFolders = mediaFilesByFolder;

const fonts = require.context('./assets/fonts', true, /\.(ttf|woff)$/);

const fontJsons = [];

fonts.keys().forEach((fontFile) => {
  const splits = fontFile.split('/');
  const folder = splits[1];
  let fileName = splits[splits.length - 1];
  let font = require(`./assets/fonts/${folder}/${fileName}`);

  const json = require(`./assets/fonts/${folder}/projectMeta.json`);
  fontJsons.push(json);

  var myfont = new FontFace(json.title, `url(${font})`);
  myfont.load().then(function (loadedFont) {
    document.fonts.add(loadedFont);
  }).catch(function (error) {
    console.log(error);
  });
});

function App() {
  const [projectsSwiper, setProjectsSwiper] = useState(null);
  const [projectsSwiperIndex, setProjectsSwiperIndex] = useState(0);
  const [typefaceSwiperIndex, setTypefaceSwiperIndex] = useState(2);
  const [navigationSwiper, setNavigationSwiper] = useState(null);
  const [projectsPagesSwipers, setProjectsPagesSwipers] = useState([]);
  const [isUp, setIsUp] = useState(false);
  const [isLeft, setIsLeft] = useState(false);
  const [isRight, setIsRight] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
  const [isDown, setIsDown] = useState(false);
  const [muted, setMuted] = useState(true);
  const [showClose, setShowClose] = useState(false);
  const [savedSliderIndexes, setSavedSliderIndexes] = useState([]);
  const [videoEnded, setVideoEnded] = useState(false);
  const [isIdle, setIsIdle] = useState(false);
  const [lastMouseMove, setLastMouseMove] = useState(Date.now());
  const [showDetails, setShowDetails] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const [showImprint, setShowImprint] = useState(false);
  const [showContactInformation, setShowContactInformation] = useState(false);
  const [colorInverted, setColorInverted] = useState(isMobile);
  const debug = false;
  const [isMouseInProjectsNavigation, setIsMouseInProjectsNavigation] = useState(false);
  const [isMouseInTypefacesNavigation, setIsMouseInTypefacesNavigation] = useState(false);
  const [isMouseInSwiper, setIsMouseInSwiper] = useState(false);
  const [isMouseInFontSizeSwiper, setIsMouseInFontSizeSwiper] = useState(false);
  const [isMouseInNavigationTitles, setIsMouseInNavigationTitles] = useState(false);
  const [isMouseInDetailRight, setIsMouseInDetailRight] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', !colorInverted ? 'inverted' : '');

    // Create a smooth transition for the theme-color meta tag
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      const startColor = colorInverted ? [250, 250, 250] : [16, 16, 16]; // From previous color
      const endColor = colorInverted ? [16, 16, 16] : [250, 250, 250]; // To new color
      const duration = 340; // Match your CSS transition duration (500ms)
      const startTime = performance.now();

      const animateThemeColor = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);

        // Calculate the current color using linear interpolation
        const currentColor = [
          Math.round(startColor[0] + (endColor[0] - startColor[0]) * progress),
          Math.round(startColor[1] + (endColor[1] - startColor[1]) * progress),
          Math.round(startColor[2] + (endColor[2] - startColor[2]) * progress)
        ];

        // Update the meta tag
        metaThemeColor.setAttribute('content', `rgb(${currentColor[0]}, ${currentColor[1]}, ${currentColor[2]})`);

        // Continue the animation if not complete
        if (progress < 1) {
          requestAnimationFrame(animateThemeColor);
        }
      };

      requestAnimationFrame(animateThemeColor);
    }

    const archiveContainer = document.querySelector('.archive-container');
    if (archiveContainer) {
      archiveContainer.classList.add('color-inverted-transition');
      setTimeout(() => {
        archiveContainer.classList.remove('color-inverted-transition');
      }, 250);
    }
  }, [colorInverted]);

  const handleVideoEnd = () => {
    document.getElementsByClassName('intro-video')[0].classList.add('ended');
    setTimeout(() => {
      setVideoEnded(true);
    }, 1500); // CSS animation time
  };

  const addProjectsPagesSwiper = (swiper, index) => {
    projectsPagesSwipers[index] = swiper;
    setProjectsPagesSwipers(projectsPagesSwipers);
  }

  const toggleBackgroundColor = () => {
    setColorInverted(!colorInverted);
  }

  const switchProjectSlide = () => {
    if (isDown && projectsSwiper) {
      projectsSwiper.slidePrev();
      return;
    }
    if (isUp && projectsSwiper) {
      projectsSwiper.slideNext();
      return;
    }
  };

  let currentPage;

  switch (selectedPage) {
    case 0:
      currentPage = (
        <React.Fragment>
          {isMobile ? (
            <div className='flex h-full w-full justify-center'>
              <div style={{ position: 'absolute', left: '0', bottom: '50%', zIndex: 2, transform: 'translateY(50%)' }} className='pl-4'>
                {typeof savedSliderIndexes[projectsSwiperIndex] === 'number' ? savedSliderIndexes[projectsSwiperIndex] + 1 : 1}
              </div>
              <div style={{ position: 'absolute', right: '0', bottom: '50%', zIndex: 2, transform: 'translateY(50%)' }} className='pr-4'>
                {projectFolderSizes[projectsSwiperIndex] || 0}
              </div>
              <div className='project-swiper-mobile'>
                <Swiper
                  className='swiper h-full w-full'
                  slidesPerView={1}
                  allowTouchMove={true}
                  direction='vertical'
                  onSwiper={setProjectsSwiper}
                  initialSlide={projectsSwiperIndex}
                  centeredSlides={true}
                  loop={true}
                  touchRatio={1}
                  modules={[Virtual]}
                  virtual
                  onSlideChange={(swiper) => {
                    navigationSwiper?.slideToLoop(swiper.realIndex);
                    setProjectsSwiperIndex(swiper.realIndex % projectFolders.length);
                  }}
                >
                  {[...projectFolders, ...projectFolders, ...projectFolders, ...projectFolders, ...projectFolders].map((videoFileByFolder, index) => (
                    <SwiperSlide key={index} virtualIndex={index}>
                      <Slider
                        savedSliderIndexes={savedSliderIndexes}
                        setSavedSliderIndexes={setSavedSliderIndexes}
                        information={projectFolders[projectsSwiperIndex % projectFolders.length][0].information}
                        muted={true}
                        addProjectsPagesSwiper={addProjectsPagesSwiper}
                        isRight={isRight}
                        isLeft={isLeft}
                        index={index % projectFolders.length}
                        swiperIndex={projectsSwiperIndex % projectFolders.length}
                        media={videoFileByFolder.map((v) => v.video)}
                        posterImage={videoFileByFolder.map((v) => v.posterImage)}
                        mobile={true}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div className='flex h-full navigation-mobile-vertical'>
                <div className='mr-2'>
                  <div>
                    Title:
                  </div>
                </div>
                <Swiper
                  allowTouchMove={false}
                  loop={true}
                  onSwiper={(swiper) => {
                    setNavigationSwiper(swiper);
                  }}
                  slidesPerView={30}
                  direction='vertical'
                  centeredSlides={false}
                  touchRatio={1}
                  style={{ height: 'calc(100dvh - var(--mobile-header-height) - var(--mobile-header-height))' }}
                >
                  {[...projectFolders, ...projectFolders, ...projectFolders, ...projectFolders, ...projectFolders].map((folder, index) => (
                    <SwiperSlide key={index}>
                      <div className={`${projectsSwiperIndex === index ? 'active' : ''}`}>
                        {folder[0].details_title}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
          ) : (
            <>
              <div className='project-swiper'>
                <Swiper
                  className='swiper h-full w-full'
                  slidesPerView={1}
                  allowTouchMove={true}
                  direction='vertical'
                  onSwiper={setProjectsSwiper}
                  initialSlide={projectsSwiperIndex}
                  centeredSlides={true}
                  loop={true}
                  virtual
                  modules={[Virtual]}
                  onSlideChange={(swiper) => {
                    if (navigationSwiper) {
                      navigationSwiper.slideToLoop(swiper.realIndex);
                    }

                    setProjectsSwiperIndex(swiper.realIndex % projectFolders.length)
                  }}
                >
                  {[...projectFolders, ...projectFolders].map((videoFileByFolder, index) => (
                    <SwiperSlide key={index} virtualIndex={index}>
                      <Slider
                        switchProjectSlide={switchProjectSlide}
                        savedSliderIndexes={savedSliderIndexes}
                        setSavedSliderIndexes={setSavedSliderIndexes}
                        information={projectFolders[projectsSwiperIndex][0].information}
                        projectFolderLength={projectFolders.length}
                        showInformation={showClose}
                        muted={muted}
                        addProjectsPagesSwiper={addProjectsPagesSwiper}
                        isRight={isRight}
                        isLeft={isLeft}
                        index={index % projectFolders.length}
                        swiperIndex={projectsSwiperIndex}
                        media={videoFileByFolder.map((v) => v.video)}
                        posterImage={videoFileByFolder.map((v) => v.posterImage)}
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div className='archive-container'>
                <div className='flex h-full font-semi-bold'>
                  <div className='navigation-titles double-line-height'>
                    <div className='opacity-0'>
                      Glyphs:
                    </div>
                    <div>
                      Title:
                    </div>
                    <div>
                      Client:
                    </div>
                    <div>
                      Type:
                    </div>
                    <div className='opacity-0'>
                      Glyphs:
                    </div>
                  </div>
                  <div className='navigation-left'>
                    <Navigation
                      setNavigationSwiper={setNavigationSwiper}
                      isDown={isDown}
                      isUp={isUp}
                      swiperIndex={projectsSwiperIndex}
                      projectMetas={projectFolders}
                    />
                  </div>
                </div>
                <div className='detail-right'>
                  {typeof savedSliderIndexes[projectsSwiperIndex] === 'number' ? savedSliderIndexes[projectsSwiperIndex] + 1 : 1} / {projectFolderSizes[projectsSwiperIndex] || 0}
                </div>
              </div>
            </>
          )}
        </React.Fragment>
      );
      break;
    case 1:
      currentPage = (
        <React.Fragment>
          {isMobile ? (
            <div className='typeface-parent-container-mobile'>
              <Typefaces
                showInformation={showClose}
                fonts={fontJsons}
                isDown={isDown}
                isUp={isUp}
                mobile={true}
                typefaceSwiperIndex={typefaceSwiperIndex}
                setTypefaceSwiperIndex={setTypefaceSwiperIndex}
              />
            </div>
          ) : (
            <div className='typeface-parent-container'>
              <div className='navigation-titles double-line-height'>
                <div>
                  Title:
                </div>
                <div>
                  Glyphs:
                </div>
                <div>
                  Type:
                </div>
              </div>
              <Typefaces
                showInformation={showClose}
                fonts={fontJsons}
                isDown={isDown}
                isUp={isUp}
                typefaceSwiperIndex={typefaceSwiperIndex}
                setTypefaceSwiperIndex={setTypefaceSwiperIndex}
              />
            </div>
          )}
        </React.Fragment>
      );
      break;
    default:
      break;
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const now = Date.now();
      const diff = now - lastMouseMove;
      if (diff > 180 * 1000) { // 180 seconds
        setIsIdle(!isMobile && true);
      }
    }, 1000); // check every second

    const handleMouseMove = (e) => {
      setLastMouseMove(Date.now());

      if (isIdle) {
        const introVideo = document.getElementsByClassName('intro-video')[0];

        if (introVideo) {
          introVideo.classList.add('ended');
        }

        setTimeout(() => {
          setIsIdle(false);
        }, 1500); // CSS animation time
      }

      if (!projectsSwiper) {
        return;
      }

      // Get the active slide element directly from the Swiper instance
      const activeSlideElement = projectsSwiper.slides ? 
        Array.from(projectsSwiper.slides).find(slide => slide.classList.contains('swiper-slide-visible')) || 
        (projectsSwiper.slides[1] ? projectsSwiper.slides[1] : projectsSwiper.slides[0]) : 
        null;

      // Find the custom-swiper-wrapper within the active slide's parent element
      const customSwiperWrapper = activeSlideElement?.querySelector('.custom-swiper-wrapper') ||
        activeSlideElement?.closest('.swiper-slide-active')?.querySelector('.custom-swiper-wrapper');

      const rect1 = customSwiperWrapper?.getBoundingClientRect();
      const rect2 = document.getElementById('projectsNavigation')?.getBoundingClientRect();
      const rect3 = document.getElementById('typefacesNavigation')?.getBoundingClientRect();
      const rect4 = document.getElementById('fontSizeSwiper')?.getBoundingClientRect();
      const rect5 = document.getElementsByClassName('navigation-titles')[0]?.getBoundingClientRect();
      const rect6 = document.getElementsByClassName('detail-right')[0]?.getBoundingClientRect();

      if (rect2) {
        setIsMouseInProjectsNavigation(e.clientX >= rect2.left && e.clientX <= rect2.right && e.clientY >= rect2.top && e.clientY <= rect2.bottom);
      }

      if (rect3) {
        setIsMouseInTypefacesNavigation(e.clientX >= rect3.left && e.clientX <= rect3.right && e.clientY >= rect3.top && e.clientY <= rect3.bottom);
      }

      if (rect1) {
        setIsMouseInSwiper(e.clientX >= rect1.left && e.clientX <= rect1.right && e.clientY >= rect1.top && e.clientY <= rect1.bottom);
      }

      if (rect4) {
        setIsMouseInFontSizeSwiper(e.clientX >= rect4.left && e.clientX <= rect4.right && e.clientY >= rect4.top && e.clientY <= rect4.bottom);
      }

      if (rect5) {
        setIsMouseInNavigationTitles(e.clientX >= rect5.left && e.clientX <= rect5.right && e.clientY >= rect5.top && e.clientY <= rect5.bottom);
      }

      if (rect6) {
        setIsMouseInDetailRight(e.clientX >= rect6.left && e.clientX <= rect6.right && e.clientY >= rect6.top && e.clientY <= rect6.bottom);
      }

      if (isMouseInProjectsNavigation && !showDetails) {
        const mouseY = e.clientY - rect2.top;
        const isUpperHalfInNavigation = mouseY <= rect2.height / 2;
        setIsDown(!isUpperHalfInNavigation);
        setIsUp(isUpperHalfInNavigation);
        setIsLeft(false);
        setIsRight(false);
        document.body.style.cursor = 'none';
      } else if (isMouseInSwiper && !isMouseInNavigationTitles && !isMouseInDetailRight && !showDetails) {
        const mouseX = e.clientX - rect1.left;
        const isLeftHalfInSwiper = mouseX <= rect1.width / 2;
        setIsLeft(isLeftHalfInSwiper);
        setIsRight(!isLeftHalfInSwiper);
        setIsDown(false);
        setIsUp(false);
        document.body.style.cursor = 'none';
      } else if (isMouseInTypefacesNavigation) {
        const mouseY = e.clientY - rect3.top;
        const isUpperHalfInNavigation = mouseY <= rect3.height / 2;
        setIsDown(!isUpperHalfInNavigation);
        setIsUp(isUpperHalfInNavigation);
        setIsLeft(false);
        setIsRight(false);
        document.body.style.cursor = 'none';
      } else if (isMouseInFontSizeSwiper) {
        const mouseY = e.clientY - rect3.top;
        const isUpperHalfInNavigation = mouseY <= rect3.height / 2;
        setIsDown(!isUpperHalfInNavigation);
        setIsUp(isUpperHalfInNavigation);
        setIsLeft(false);
        setIsRight(false);
        document.body.style.cursor = 'none';
      } else {
        setIsLeft(false);
        setIsRight(false);
        setIsDown(false);
        setIsUp(false);
        document.body.style.cursor = 'default';
      }

      const cursor = document.getElementById('cursor');

      if (cursor) {
        cursor.style.left = (e.pageX - 10) + 'px';
        cursor.style.top = (e.pageY - 10) + 'px';
        cursor.style.transition = 'transform 0.4s ease';

        if (isDown) {
          cursor.style.transform = 'rotate(90deg)';
        }

        if (isRight) {
          cursor.style.transform = 'rotate(0deg)';
        }

        if (isUp) {
          cursor.style.transform = 'rotate(-90deg)';
        }

        if (isLeft) {
          cursor.style.transform = 'rotate(180deg)';
        }
      }
    };

    const handleKeyDown = (e) => {
      // Only handle keyboard navigation if the about page is not open
      if (showAbout || showDetails) {
        return; // Exit early if about page is open
      }

      if (e.key === 'ArrowUp') {
        if (projectsSwiper) {
          projectsSwiper.slidePrev();
        }
      }
      if (e.key === 'ArrowDown') {
        if (projectsSwiper) {
          projectsSwiper.slideNext();
        }
      }
      if (e.key === 'ArrowLeft') {
        if (projectsPagesSwipers[projectsSwiper?.realIndex % projectFolders.length]) {
          projectsPagesSwipers[projectsSwiper.realIndex  % projectFolders.length].slidePrev();
        }
      }
      if (e.key === 'ArrowRight') {
        if (projectsPagesSwipers[projectsSwiper?.realIndex % projectFolders.length]) {
          projectsPagesSwipers[projectsSwiper.realIndex  % projectFolders.length].slideNext();
        }
      }
    }

    if (!isMobile) {
      document.addEventListener('pointermove', handleMouseMove);
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      if (!isMobile) {
        document.removeEventListener('keydown', handleKeyDown);
        document.removeEventListener('pointermove', handleMouseMove);
      }
      clearInterval(timer);
    };
  }, [projectsSwiperIndex, navigationSwiper, lastMouseMove, projectsSwiper, isIdle, showDetails, showAbout, projectsPagesSwipers, isMouseInProjectsNavigation, isMouseInTypefacesNavigation, isMouseInSwiper, isMouseInFontSizeSwiper, isMouseInNavigationTitles, isMouseInDetailRight, isDown, isLeft, isRight, isUp]);

  return (
    <React.Fragment>
      {isMobile ? (
        <div className="mobile-app">
          {!debug && !videoEnded ? (
            <div className='flex items-center justify-center h-full'>
              <img
                src={require('./assets/videos/intro-video-black.gif')}
                alt="Intro animation"
                className="intro-video"
                width="100%"
                height="100%"
                onLoad={() => setTimeout(handleVideoEnd, 4000)}
              />
            </div>) : (
            <div className="mobile-app-content">
              <MobileHeader
                showClose={showClose}
                setShowClose={setShowClose}
                setSelectedPage={setSelectedPage}
                selectedPage={selectedPage}
                showAbout={showAbout}
                setShowAbout={setShowAbout}
                setShowDetails={setShowDetails}
                showDetails={showDetails}
                showContactInformation={showContactInformation}
                setShowContactInformation={setShowContactInformation}
                showImprint={showImprint}
                setShowImprint={setShowImprint}
              />
              <div className="mobile-content w-full">{currentPage}</div>
              {showAbout && <AboutDetailsMobile />}
              {showImprint && <Imprint mobile={isMobile} />}
              {showDetails && <ProjectDetailsMobile
                selectedPage={selectedPage}
                projectMetas={projectFolders}
                projectIndex={projectsSwiperIndex}
                typefaceSwiperIndex={typefaceSwiperIndex}
                fontJsons={fontJsons}
                slideIndex={savedSliderIndexes[projectsSwiperIndex]}
              />}
              <MobileFooter
                showInformation={showClose}
                setMuted={setMuted}
                muted={muted}
                isArchiveSelected={selectedPage === 0}
                isTypefaceSelected={selectedPage === 1}
                toggleBackgroundColor={toggleBackgroundColor}
                typefaceSwiperIndex={typefaceSwiperIndex}
                typefacesFolderSize={fontJsons.length}
                folderSizes={projectFolderSizes}
                setShowDetails={setShowDetails}
                showDetails={showDetails}
                setShowAbout={setShowAbout}
                showAbout={showAbout}
                setShowContactInformation={setShowContactInformation}
                showContactInformation={showContactInformation}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="app">
          {(!debug && !videoEnded) || isIdle ? (
            <div className='flex items-center justify-center h-full'>
              <video
                className='intro-video'
                muted={true}
                loop={isIdle}
                onEnded={isIdle ? null : handleVideoEnd}
                autoPlay
                playsInline
                width="100%"
                height="100%"
              >
                <source src={colorInverted ? require('./assets/videos/intro-black.mp4') : require('./assets/videos/intro-white.mp4')} type="video/mp4" />
              </video>
            </div>
          ) : (
            <div className="app-content">
              <Header
                showClose={showClose}
                setShowClose={setShowClose}
                setSelectedPage={setSelectedPage}
                selectedPage={selectedPage}
                showAbout={showAbout}
                setShowAbout={setShowAbout}
                setShowDetails={setShowDetails}
                showDetails={showDetails}
                showContactInformation={showContactInformation}
                setShowContactInformation={setShowContactInformation}
                showImprint={showImprint}
                setShowImprint={setShowImprint}
              />
              {(isUp || isDown || isLeft || isRight) && <img
                src={!colorInverted ? arrowBlackSvg : arrowWhiteSvg}
                style={{ width: '25px', height: '25px' }}
                muted
                autoPlay
                loop
                id='cursor'
                className='cursor'
                alt='up'
              />}
              <div className='content'>{currentPage}</div>
              {showAbout && <AboutDetails
              />}
              {showDetails && <ProjectDetails
                selectedPage={selectedPage}
                projectMetas={projectFolders}
                projectIndex={projectsSwiperIndex}
                typefaceSwiperIndex={typefaceSwiperIndex}
                fontJsons={fontJsons}
                slideIndex={savedSliderIndexes[projectsSwiperIndex]}
              />}
              {showImprint && <Imprint />}
              <Footer
                showInformation={showClose}
                setMuted={setMuted}
                muted={muted}
                isArchiveSelected={selectedPage === 0}
                isTypefaceSelected={selectedPage === 1}
                toggleBackgroundColor={toggleBackgroundColor}
                swiperIndex={projectsSwiperIndex}
                typefaceSwiperIndex={typefaceSwiperIndex}
                typefacesFolderSize={fontJsons.length}
                folderSizes={projectFolderSizes}
                setShowDetails={setShowDetails}
                showDetails={showDetails}
                setShowAbout={setShowAbout}
                setShowContactInformation={setShowContactInformation}
              />
            </div>
          )}
        </div>
      )}
    </React.Fragment>
  );
}

export default App;
